import { getBooleanFF } from '@atlaskit/platform-feature-flags';
import { suggestionGenerator, resolvedMVPResponseGenerator } from './streaming-service';

// NOTE: It's important that we maintain a consistent API regardless of which endpoint we hit.
// This is a generic interface we should be able to use for any version of the provider.

export const fetchAIParagraphs = (proactiveAIApiUrl, locale) => paragraphs => getBooleanFF('platform.editor.ai-proactive-ai-api-url_k6yy7') ? fetchAIParagraphsV1(proactiveAIApiUrl, locale, paragraphs) : fetchAIParagraphsMVP(proactiveAIApiUrl, paragraphs);

/**
 * This will filter out chunks from being streamed to the service which are not valid.
 */
export const isChunkExcluded = chunk => chunk.from === chunk.to || !chunk.text || !chunk.text.trim().length;

/**
 * fetchAIMVP is for the MVP endpoint which only supports a single string
 */
/* istanbul ignore next */
const fetchAIMVP = async (proactiveAIApiUrl, chunk) => {
  const payload = {
    smartsModel: 'CC_SMARTS_SPELLING_CORRECTION_MODEL',
    inputText: chunk.text
  };
  const abortController = new AbortController();
  const fetchInit = {
    method: 'POST',
    body: JSON.stringify(payload),
    credentials: 'include',
    signal: abortController.signal,
    mode: 'cors'
  };
  const response = await fetch(proactiveAIApiUrl, {
    ...fetchInit,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  });
  return response.json();
};

/* istanbul ignore next */
// This is the original MVP endpoint used for the initial spike. This will be replaced by the V1 endpoint.
const fetchAIParagraphsMVP = (proactiveAIApiUrl, paragraphs) => {
  const included = paragraphs.filter(chunk => !isChunkExcluded(chunk));
  const promises = included.map(chunk => fetchAIMVP(proactiveAIApiUrl, chunk));
  return resolvedMVPResponseGenerator({
    paragraphs: included,
    promises
  });
};

/* istanbul ignore next */
// This V1 endpoint is the final endpoint we're targetting for hello release.
const fetchAIParagraphsV1 = (proactiveAIApiUrl, locale, paragraphs) => {
  const included = paragraphs.filter(chunk => !isChunkExcluded(chunk));
  if (!!included.length) {
    const requests = {};
    included.forEach(({
      id,
      text
    }) => {
      requests[id] = text;
    });

    /**
     * API Spec documented at https://hello.atlassian.net/wiki/spaces/CA3/pages/3776161653/Bulk+Spelling+and+Grammar+Endpoint
     */
    const payload = {
      requests
    };
    return suggestionGenerator({
      endpoint: proactiveAIApiUrl,
      paragraphs: included,
      payload: JSON.stringify(payload),
      abortController: new AbortController()
    });
  }
  return;
};